import styled from "styled-components";
import { bodyColor, errorColor } from "../../../../../config/constants";

// Styles
export const EvaluationDiv = styled.div`
  margin: 5px auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 85%;
    height: auto;
    flex-direction: column;
    align-items: flex-end;
    background-color: transparent;
    box-shadow: none;
    transition: all 0.5s ease-out;
  }
`;
export const EvaluationInfoDiv = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const EvaluationTitleDiv = styled.div`
  margin-left: 15px;
  width: 150px;
  height: 100%;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 100%;
    position: relative;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
`;
export const EvaluationTitle = styled.p`
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: left;
`;
export const DetailsDiv = styled.div`
  width: 80px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
`;
export const DetailsButton = styled.button`
  width: 33px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid ${bodyColor};
  cursor: pointer;
`;
export const IconImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const EvaluationDataDiv = styled.div`
  padding: 0 2px 2px;
  width: 100%;
  display: flex;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const ColumnsDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  overflow-x: auto;
`;
export const Column = styled.div`
  min-width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  background-color: ${({ background }) => background && background};
`;
export const Box = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 16px;
  padding-right: 10px;
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify && justify};
  box-shadow: ${({ topShadow }) => topShadow && "inset 0 5px 10px -7px rgb(0 0 0 / 10%)"};
  background-color: ${({ background }) => background && background};
  border-left: ${({ borderLeft }) => borderLeft && borderLeft};
  border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
`;
export const Text = styled.p`
  color: ${({ isError }) => (isError ? errorColor : "#000")};
  font-size: 14px;
  font-weight: ${({ strong }) => (strong ? "600" : "400")};
`;
export const EditButton = styled.button`
  margin-right: 10px;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
export const EditImg = styled.img`
  width: 20px;
  height: 20px;
`;
